import React, { useEffect } from 'react';
import { SC } from '../constants/colors';

export function Toast({ note, onClose }: { note: any; onClose: () => void }) {
  useEffect(() => { const t = setTimeout(onClose, 8000); return () => clearTimeout(t); }, [onClose]);
  const c = SC[note.severity] || '#6b7280';
  return (
    <div style={{
      background: '#1e293b',
      border: `1px solid ${c}44`,
      borderLeft: `3px solid ${c}`,
      borderRadius: 8,
      padding: '10px 14px',
      marginBottom: 6,
      boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
      minWidth: 0,
      wordBreak: 'break-word',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4, gap: 8, alignItems: 'flex-start' }}>
        <span style={{ fontSize: 11, color: c, fontWeight: 700, letterSpacing: 0.3 }}>
          {note.severity?.toUpperCase()} · {note.type?.replace(/_/g, ' ')}
        </span>
        <button
          onClick={onClose}
          style={{ background: 'none', border: 'none', color: '#64748b', cursor: 'pointer', fontSize: 16, lineHeight: 1, flexShrink: 0, padding: 0 }}
        >×</button>
      </div>
      <div style={{ fontSize: 13, color: '#e2e8f0', lineHeight: 1.4 }}>{note.message}</div>
      {note.from && (
        <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>{note.from} → {note.to}</div>
      )}
    </div>
  );
}
